import { render, staticRenderFns } from "./SortingControls.vue?vue&type=template&id=e0dfc3be"
import script from "./SortingControls.vue?vue&type=script&lang=ts"
export * from "./SortingControls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports